import React from "react";
import "./BookingFlow.css"; // pulls in .bf-header, .bf-card, etc.

export default function HeaderDriverCard({ driver, vehicle }) {
  console.log("driver-----", driver);
  const {
    firstName,
    lastName,
    vehicleModel,
    vehicleRegNo,
    profileImage,
    phoneNumber,
  } = driver || {};

  const {vehicleClass} = vehicle || {};
  const avatarFallback = "https://avatar.iran.liara.run/public/13";
  const avatarSrc = profileImage?.trim() ? profileImage : avatarFallback;

  const plateRegex = /^([A-Z]{2})(\d{2})([A-Z]{1,2})(\d{1,4})$/i;

function formatPlate(input) {
  if (input == null) return "";                     // handles undefined/null
  const raw = String(input).toUpperCase()
    .replace(/[\s-]/g, "")                          // remove spaces/dashes
    .trim();

  if (!raw) return "";

  // If regex matches, format with spaces; otherwise just return normalized text
  return raw.replace(plateRegex, (_m, p1, p2, p3, p4) => `${p1} ${p2} ${p3} ${p4}`) || raw;
}

function capitalizeFirst(str) {
  if (str == null) return "";

  const s = String(str);                 // normalize
  if (s.trim().toUpperCase() === "SUV")  // case-insensitive match
    return "SUV";

  const t = s.trimStart();               // keep trailing spaces if you want
  return t.charAt(0).toUpperCase() + t.slice(1);
}

  return (
    <>
      <header className="bf-header">
        <img src="/icons/logo.svg" alt="Taxi Tribe" className="bf-logo" />
        {/* <h1 className="bf-logo-text">Taxi Tribe</h1> */}
      </header>
      <div className="bf-card">
        <h2 className="bf-card-title">Hey there</h2>
        <p className="bf-card-subtitle">
          You’re all set to ride with {firstName}.
        </p>
        {/* <img src="https://avatar.iran.liara.run/public/13" alt="Driver avatar" className="bf-avatar" /> */}
        <img src={avatarSrc} alt="Driver avatar" className="bf-avatar" />
        <div className="bf-info-row">
          <div className="bf-info-item">
            <div className="bf-info-label">Driver name</div>
            <div className="bf-info-value">
              <img
                src="/icons/id_card.svg"
                alt="Driver icon"
                className="bf-info-icon"
              />
              <span>{`${firstName} ${lastName}`}</span>
            </div>
          </div>
          <div className="bf-info-item">
            <div className="bf-info-label">Average ratings</div>
            <div className="bf-info-value">
              <img
                src="/icons/kid_star.svg"
                alt="Rating icon"
                className="bf-info-icon"
              />
              <span>4.5</span>
            </div>
          </div>
        </div>
        <div className="bf-info-row">
          <div className="bf-info-item">
            <div className="bf-info-label">Vehicle number</div>
            <div className="bf-info-value">
              <img
                src="/icons/search_hands_free.svg"
                alt="Vehicle icon"
                className="bf-info-icon"
              />
              <span>{formatPlate(vehicleRegNo)}</span>
            </div>
          </div>
          <div className="bf-info-item">
            <div className="bf-info-label">Vehicle type</div>
            <div className="bf-info-value">
              <img
                src="/icons/local_taxi.svg"
                alt="Car type icon"
                className="bf-info-icon"
              />
              <span>{capitalizeFirst(vehicleClass)}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
